import { ReactNode } from 'react'
import { Config, usePopperTooltip } from 'react-popper-tooltip'

type TooltipProps = Pick<Config, 'placement' | 'trigger'> & {
  content: ReactNode
  children: ReactNode
  className?: string
}

export default function Tooltip({
  content,
  children,
  placement,
  trigger,
  className,
}: TooltipProps) {
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible } =
    usePopperTooltip({
      placement,
      trigger,
      interactive: true,
    })
  const { style, ...tooltipProps } = getTooltipProps()

  return (
    <>
      <div ref={setTriggerRef} className={className}>
        {children}
      </div>

      {visible && (
        <div
          ref={setTooltipRef}
          className=""
          style={{
            ...style,
          }}
          {...tooltipProps}
        >
          {content}
        </div>
      )}
    </>
  )
}
